webpackJsonp([172411548396689],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Impressum = function Impressum() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'main' },
	    _react2.default.createElement(
	      'section',
	      { id: 'angebot', className: 'main style1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Impressum'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Informationspflicht laut \xA75 E-Commerce Gesetz, \xA714 Unternehmensgesetzbuch, \xA763 Gewerbeordnung und Offenlegungspflicht laut \xA725 Mediengesetz.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'S & H Finanzberatung',
	            _react2.default.createElement('br', null),
	            'Stiftgasse 11, ',
	            _react2.default.createElement('br', null),
	            '6020 Innsbruck, ',
	            _react2.default.createElement('br', null),
	            '\xD6sterreich'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Unternehmensgegenstand:'
	            ),
	            ' Wirtschafts- und Finanzdienstleistungen',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'UID-Nummer:'
	            ),
	            ' ATU12345678',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Firmenbuchnummer:'
	            ),
	            ' 211023d',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Firmenbuchgericht:'
	            ),
	            ' Handelsgericht Innsbruck',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Firmensitz:'
	            ),
	            ' 6020 Innsbruck'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Tel.:'
	            ),
	            ' +43 512 57 11 27',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Fax:'
	            ),
	            ' +43 512 57 11 27 27',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'E-Mail:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:info@sh-finance.at' },
	              'info@sh-finance.at'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            ' ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Verleihungsstaat:'
	            ),
	            ' \xD6sterreich'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            ' ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Gesch\xE4ftsf\xFChrer: '
	            ),
	            ' Otto Heschl'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'EU-Streitschlichtung'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Gem\xE4\xDF Verordnung \xFCber Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) m\xF6chten wir Sie \xFCber die Online-Streitbeilegungsplattform (OS-Plattform) informieren.',
	            _react2.default.createElement('br', null),
	            'Verbraucher haben die M\xF6glichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europ\xE4ischen Kommission unter ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=DE', target: '_blank' },
	              'http://ec.europa.eu/odr?tid=121123564'
	            ),
	            ' zu richten. Die daf\xFCr notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Wir m\xF6chten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Haftung f\xFCr Inhalte dieser Webseite'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Wir entwickeln die Inhalte dieser Webseite st\xE4ndig weiter und bem\xFChen uns korrekte und aktuelle Informationen bereitzustellen. Leider k\xF6nnen wir keine Haftung f\xFCr die Korrektheit aller Inhalte auf dieser Webseite \xFCbernehmen, speziell f\xFCr jene die seitens Dritter bereitgestellt wurden.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitten wir Sie uns umgehend zu kontaktieren, Sie finden die Kontaktdaten im Impressum.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Haftung f\xFCr Links auf dieser Webseite'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Unsere Webseite enth\xE4lt Links zu anderen Webseiten f\xFCr deren Inhalt wir nicht verantwortlich sind. Haftung f\xFCr verlinkte Websites besteht laut ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.ris.bka.gv.at/Dokument.wxe?Abfrage=Bundesnormen&Dokumentnummer=NOR40025813&tid=121123564', target: '_blank', rel: 'noopener' },
	              '\xA7 17 ECG'
	            ),
	            ' f\xFCr uns nicht, da wir keine Kenntnis rechtswidriger T\xE4tigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen w\xFCrden, wenn uns Rechtswidrigkeiten bekannt werden.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitten wir Sie uns zu kontaktieren, Sie finden die Kontaktdaten im Impressum.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Urheberrechtshinweis'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Datenschutzerkl\xE4rung'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'Datenschutz'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Wir haben diese Datenschutzerkl\xE4rung (Fassung 10.05.2019-121123564) verfasst, um Ihnen gem\xE4\xDF der Vorgaben der Datenschutz-Grundverordnung (EU) 2016/679 und dem ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10001597&tid=121123564', target: '_blank', rel: 'noopener' },
	              'Datenschutzgesetz (DSG)'
	            ),
	            ' zu erkl\xE4ren, welche Informationen wir sammeln, wie wir Daten verwenden und welche Entscheidungsm\xF6glichkeiten Sie als Besucher dieser Webseite haben.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Gewerbeberechtigungen'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=01365217-622b-48e4-9b9a-11955bc6328e&StandortID=0&Suchbegriff=s+%26+h&Page=1' },
	                'Gewerbliche Verm\xF6gensberatung gem\xE4\xDF \xA7 94 Ziffer 75 GewO 1994'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=01365217-622b-48e4-9b9a-11955bc6328e&StandortID=0&Suchbegriff=s+%26+h&Page=1' },
	                'Versicherungsmakler und Berater in Versicherungsangelegenheiten gem\xE4\xDF \xA7 94 Ziffer 76 GewO 1994'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=01365217-622b-48e4-9b9a-11955bc6328e&StandortID=0&Suchbegriff=s+%26+h&Page=1' },
	                'Immobilientreuh\xE4nder (Immobilienmakler, Immobilienverwalter, Bautr\xE4ger) gem\xE4\xDF \xA7 94 Ziffer 35 GewO 1994'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=01365217-622b-48e4-9b9a-11955bc6328e&StandortID=0&Suchbegriff=s+%26+h&Page=1' },
	                'Unternehmensberatung einschlie\xDFlich der Unternehmensorganisation gem\xE4\xDF \xA7 94 Ziffer 74 GewO 1994'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Zur\xFCck zur Startseite'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Impressum;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-js-e89f1bb4801fd70f1207.js